import { render } from "./QuizsScoreboard.vue?vue&type=template&id=fa62e39a&scoped=true"
import script from "./QuizsScoreboard.vue?vue&type=script&lang=js"
export * from "./QuizsScoreboard.vue?vue&type=script&lang=js"

import "./QuizsScoreboard.vue?vue&type=style&index=0&id=fa62e39a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa62e39a"]])

export default __exports__